import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Text, Checkbox } from '@upsales/components';
import bemClass from '@upsales/components/Utils/bemClass';
import Order from 'App/resources/Model/Order';
import './OpportunityRow.scss';

interface Props {
	isWarning: boolean;
	text: string;
	opportunity: Order;
	overrideOpportunity: (obj: { confirmedDate: Date | null }) => void;
	disabled?: boolean;
}

class OpportunityRowTimeFrame extends React.Component<Props> {
	static propTypes = {
		isWarning: PropTypes.bool.isRequired,
		text: PropTypes.string.isRequired,
		opportunity: PropTypes.object,
		overrideOpportunity: PropTypes.func
	};
	render() {
		const classes = new bemClass('OpportunityRow');
		const { text, isWarning, opportunity, overrideOpportunity, disabled } = this.props;

		return (
			<Flex
				className={classes.mod({ clickable: !disabled }).b()}
				onClick={
					disabled
						? undefined
						: async () => {
								await overrideOpportunity({
									confirmedDate: isWarning ? opportunity.date : null
								});
						  }
				}
			>
				<Checkbox disabled={disabled} space="mls" size="sm" checked={!isWarning} />

				<div className={classes.elem('con').b()}>
					<Text className={classes.elem('description').b()}>{text}</Text>
				</div>
			</Flex>
		);
	}
}

export default OpportunityRowTimeFrame;
